import { CSSProperties } from 'react'

import styles from './PillButtons.module.scss'

type Props = {
	items: {
		id: string
		label?: string
		icon?: JSX.Element
		onClick?: () => void
		bottomLabel?: string
		isSelected?: boolean
	}[]
	fullWidth?: boolean
	mobileFullWidth?: boolean
	className?: string
	style?: CSSProperties
}

const PillButtons = ({ items, fullWidth, mobileFullWidth, className, style }: Props) => {
	const arrClassName = [styles.pillButtons]
	if (fullWidth) arrClassName.push(styles.fullWidth)
	if (mobileFullWidth) arrClassName.push(styles.mobileFullWidth)
	if (className && className !== '') arrClassName.push(className)

	return (
		<div className={arrClassName.join(' ')} style={style}>
			{items.map((item) => (
				<div key={item.id} className={styles.pillButtonWrap}>
					<button
						className={`${styles.pillButton} ${item.isSelected ? styles.active : ''}`}
						onClick={item.onClick}
						style={{ '--button-text': `"${item.label ?? ''}"` } as CSSProperties}
					>
						{item.label}
						{item.icon && <div style={{ display: 'flex', justifyContent: 'center' }}>{item.icon}</div>}
					</button>
					{item.bottomLabel && <div className={styles.bottomLabel}>{item.bottomLabel}</div>}
				</div>
			))}
		</div>
	)
}

export default PillButtons
